import StringUtil from "../../../src/app/core/util/StringUtil";
import ReferenceData from "../constants/ReferenceData";
import { executeGet } from "../utils/apiUtils";

/**
 *  Get Site Contact Info prelogin
 */
export const getSiteContactInfoPreLogin = ({ accu, accuSpecificPrimDb, portalType }) => {
    const getSiteContactInfoPreloginSuccess = (response) => {
        if (response && response.data) {
            return response.data;
        } else {
            return null;
        }
    };
    const url = StringUtil.supplant(ReferenceData.GET_SITE_CONTACT_INFO_PRELOGIN, {
        accu,
        accuSpecificPrimDb,
        portalType
    });

    const updatedUrl = __baseApiUrl__ + url;

    return executeGet(updatedUrl, "getSiteContactInfoPreLoginFault")
        .then(getSiteContactInfoPreloginSuccess)
        .catch((err) => {
            console.log("Error - getSiteContactInfoPreLogin", err);
            throw err;
        });
};
